export interface SocOccupation {
  code: string
  title: string
  group: string
  aliases?: string[]
}

export const SOC_OCCUPATIONS: SocOccupation[] = [
  // 11 — Management
  {
    code: '11-1011',
    title: 'Chief Executives',
    group: 'Management',
    aliases: ['CEO', 'Chief Executive Officer', 'President', 'Founder', 'Co-founder', 'Co-CEO'],
  },
  {
    code: '11-1021',
    title: 'General and Operations Managers',
    group: 'Management',
    aliases: ['COO', 'Chief Operating Officer', 'VP Operations', 'Head of Operations'],
  },
  { code: '11-1031', title: 'Legislators', group: 'Management' },
  { code: '11-2011', title: 'Advertising and Promotions Managers', group: 'Management' },
  {
    code: '11-2021',
    title: 'Marketing Managers',
    group: 'Management',
    aliases: [
      'CMO',
      'Chief Marketing Officer',
      'VP Marketing',
      'VP of Marketing',
      'Head of Marketing',
    ],
  },
  { code: '11-2022', title: 'Sales Managers', group: 'Management' },
  { code: '11-2031', title: 'Public Relations and Fundraising Managers', group: 'Management' },
  { code: '11-3011', title: 'Administrative Services Managers', group: 'Management' },
  { code: '11-3012', title: 'Facilities Managers', group: 'Management' },
  {
    code: '11-3013',
    title: 'Computer and Information Systems Managers',
    group: 'Management',
    aliases: [
      'CTO',
      'Chief Technology Officer',
      'CIO',
      'Chief Information Officer',
      'VP Engineering',
      'VP of Engineering',
      'Head of Engineering',
      'IT Director',
      'IT Manager',
    ],
  },
  {
    code: '11-3021',
    title: 'Financial Managers',
    group: 'Management',
    aliases: [
      'CFO',
      'Chief Financial Officer',
      'VP Finance',
      'VP of Finance',
      'Head of Finance',
      'Controller',
      'Treasurer',
    ],
  },
  { code: '11-3031', title: 'Compensation and Benefits Managers', group: 'Management' },
  { code: '11-3051', title: 'Industrial Production Managers', group: 'Management' },
  { code: '11-3061', title: 'Purchasing Managers', group: 'Management' },
  {
    code: '11-3071',
    title: 'Transportation, Storage, and Distribution Managers',
    group: 'Management',
  },
  {
    code: '11-3111',
    title: 'Compensation, Benefits, and Job Analysis Specialists',
    group: 'Management',
  },
  {
    code: '11-3121',
    title: 'Human Resources Managers',
    group: 'Management',
    aliases: [
      'CHRO',
      'Chief People Officer',
      'CPO',
      'VP People',
      'VP HR',
      'VP of HR',
      'Head of People',
      'Head of HR',
      'People Operations Manager',
    ],
  },
  { code: '11-3131', title: 'Training and Development Managers', group: 'Management' },
  {
    code: '11-9013',
    title: 'Farmers, Ranchers, and Other Agricultural Managers',
    group: 'Management',
  },
  { code: '11-9021', title: 'Construction Managers', group: 'Management' },
  { code: '11-9031', title: 'Education and Childcare Administrators', group: 'Management' },
  { code: '11-9033', title: 'Education Administrators, Postsecondary', group: 'Management' },
  { code: '11-9041', title: 'Architectural and Engineering Managers', group: 'Management' },
  { code: '11-9051', title: 'Food Service Managers', group: 'Management' },
  { code: '11-9061', title: 'Funeral Home Managers', group: 'Management' },
  { code: '11-9071', title: 'Gaming Managers', group: 'Management' },
  { code: '11-9081', title: 'Lodging Managers', group: 'Management' },
  { code: '11-9111', title: 'Medical and Health Services Managers', group: 'Management' },
  { code: '11-9121', title: 'Natural Sciences Managers', group: 'Management' },
  { code: '11-9131', title: 'Postmasters and Mail Superintendents', group: 'Management' },
  {
    code: '11-9141',
    title: 'Property, Real Estate, and Community Association Managers',
    group: 'Management',
  },
  { code: '11-9151', title: 'Social and Community Service Managers', group: 'Management' },
  { code: '11-9161', title: 'Emergency Management Directors', group: 'Management' },
  { code: '11-9171', title: 'Funeral Service Managers', group: 'Management' },
  { code: '11-9179', title: 'Entrepreneurs and Business Owners', group: 'Management' },
  { code: '11-9199', title: 'Managers, All Other', group: 'Management' },

  // 13 — Business & Financial
  {
    code: '13-1011',
    title: 'Agents and Business Managers of Artists',
    group: 'Business & Financial',
  },
  { code: '13-1020', title: 'Buyers and Purchasing Agents', group: 'Business & Financial' },
  {
    code: '13-1031',
    title: 'Claims Adjusters, Examiners, and Investigators',
    group: 'Business & Financial',
  },
  { code: '13-1041', title: 'Compliance Officers', group: 'Business & Financial' },
  { code: '13-1051', title: 'Cost Estimators', group: 'Business & Financial' },
  { code: '13-1070', title: 'Human Resources Specialists', group: 'Business & Financial' },
  {
    code: '13-1071',
    title: 'Human Resources Specialists',
    group: 'Business & Financial',
    aliases: [
      'HR Generalist',
      'HR Coordinator',
      'HR Specialist',
      'Recruiter',
      'Talent Acquisition Specialist',
      'People Operations',
    ],
  },
  { code: '13-1075', title: 'Labor Relations Specialists', group: 'Business & Financial' },
  { code: '13-1081', title: 'Logisticians', group: 'Business & Financial' },
  { code: '13-1082', title: 'Project Management Specialists', group: 'Business & Financial' },
  {
    code: '13-1111',
    title: 'Management Analysts',
    group: 'Business & Financial',
    aliases: [
      'Management Consultant',
      'Strategy Consultant',
      'Consultant',
      'McKinsey',
      'Bain',
      'BCG',
      'MBB',
    ],
  },
  {
    code: '13-1121',
    title: 'Meeting, Convention, and Event Planners',
    group: 'Business & Financial',
  },
  { code: '13-1131', title: 'Fundraisers', group: 'Business & Financial' },
  {
    code: '13-1141',
    title: 'Compensation, Benefits, and Job Analysis Specialists',
    group: 'Business & Financial',
  },
  { code: '13-1151', title: 'Training and Development Specialists', group: 'Business & Financial' },
  {
    code: '13-1161',
    title: 'Market Research Analysts and Marketing Specialists',
    group: 'Business & Financial',
  },
  {
    code: '13-1199',
    title: 'Business Operations Specialists, All Other',
    group: 'Business & Financial',
  },
  {
    code: '13-2011',
    title: 'Accountants and Auditors',
    group: 'Business & Financial',
    aliases: ['Accountant', 'CPA', 'Auditor', 'Public Accountant', 'Tax Accountant'],
  },
  { code: '13-2020', title: 'Property Appraisers and Assessors', group: 'Business & Financial' },
  { code: '13-2031', title: 'Budget Analysts', group: 'Business & Financial' },
  { code: '13-2041', title: 'Credit Analysts', group: 'Business & Financial' },
  {
    code: '13-2051',
    title: 'Financial and Investment Analysts',
    group: 'Business & Financial',
    aliases: [
      'Financial Analyst',
      'Finance Analyst',
      'FP&A Analyst',
      'Investment Analyst',
      'Equity Research Analyst',
    ],
  },
  { code: '13-2052', title: 'Personal Financial Advisors', group: 'Business & Financial' },
  { code: '13-2053', title: 'Insurance Underwriters', group: 'Business & Financial' },
  { code: '13-2054', title: 'Financial Risk Specialists', group: 'Business & Financial' },
  { code: '13-2061', title: 'Financial Examiners', group: 'Business & Financial' },
  { code: '13-2071', title: 'Credit Counselors', group: 'Business & Financial' },
  { code: '13-2072', title: 'Loan Officers', group: 'Business & Financial' },
  { code: '13-2081', title: 'Tax Examiners and Collectors', group: 'Business & Financial' },
  { code: '13-2082', title: 'Tax Preparers', group: 'Business & Financial' },
  { code: '13-2099', title: 'Financial Specialists, All Other', group: 'Business & Financial' },

  // 15 — Computer & Mathematical
  {
    code: '15-1211',
    title: 'Computer Systems Analysts',
    group: 'Computer & Mathematical',
    aliases: ['Systems Analyst', 'IT Analyst', 'Business Systems Analyst'],
  },
  {
    code: '15-1212',
    title: 'Information Security Analysts',
    group: 'Computer & Mathematical',
    aliases: [
      'Cybersecurity Analyst',
      'Cyber Analyst',
      'Security Analyst',
      'InfoSec Analyst',
      'GRC Analyst',
      'Governance Risk Compliance',
      'Penetration Tester',
      'Pen Tester',
      'Ethical Hacker',
      'CISO',
      'Chief Information Security Officer',
      'AppSec Engineer',
      'Cybersecurity Engineer',
    ],
  },
  {
    code: '15-1221',
    title: 'Computer and Information Research Scientists',
    group: 'Computer & Mathematical',
  },
  {
    code: '15-1231',
    title: 'Computer Network Support Specialists',
    group: 'Computer & Mathematical',
  },
  { code: '15-1232', title: 'Computer User Support Specialists', group: 'Computer & Mathematical' },
  { code: '15-1241', title: 'Computer Network Architects', group: 'Computer & Mathematical' },
  { code: '15-1242', title: 'Database Administrators', group: 'Computer & Mathematical' },
  { code: '15-1243', title: 'Database Architects', group: 'Computer & Mathematical' },
  {
    code: '15-1244',
    title: 'Network and Computer Systems Administrators',
    group: 'Computer & Mathematical',
    aliases: [
      'Sysadmin',
      'IT Admin',
      'Network Admin',
      'Network Administrator',
      'Systems Administrator',
      'IT Support',
    ],
  },
  { code: '15-1245', title: 'Data Scientists', group: 'Computer & Mathematical' },
  { code: '15-1246', title: 'Data Engineers', group: 'Computer & Mathematical' },
  {
    code: '15-1251',
    title: 'Computer Programmers',
    group: 'Computer & Mathematical',
    aliases: ['Programmer', 'Coder', 'Developer'],
  },
  {
    code: '15-1252',
    title: 'Software Developers',
    group: 'Computer & Mathematical',
    aliases: ['Software Engineer', 'SWE', 'App Developer', 'Application Developer'],
  },
  {
    code: '15-1253',
    title: 'Software Quality Assurance Analysts and Testers',
    group: 'Computer & Mathematical',
  },
  { code: '15-1254', title: 'Web Developers', group: 'Computer & Mathematical' },
  {
    code: '15-1255',
    title: 'Web and Digital Interface Designers',
    group: 'Computer & Mathematical',
  },
  {
    code: '15-1256',
    title: 'DevOps Engineers',
    group: 'Computer & Mathematical',
    aliases: [
      'DevOps',
      'DevOps Engineer',
      'Infrastructure Engineer',
      'Release Engineer',
      'Build Engineer',
    ],
  },
  { code: '15-1299', title: 'Computer Occupations, All Other', group: 'Computer & Mathematical' },
  { code: '15-2011', title: 'Actuaries', group: 'Computer & Mathematical' },
  { code: '15-2021', title: 'Mathematicians', group: 'Computer & Mathematical' },
  { code: '15-2031', title: 'Operations Research Analysts', group: 'Computer & Mathematical' },
  { code: '15-2041', title: 'Statisticians', group: 'Computer & Mathematical' },
  {
    code: '15-2051',
    title: 'Data Scientists and Mathematical Science Occupations',
    group: 'Computer & Mathematical',
  },
  {
    code: '15-2099',
    title: 'Mathematical Science Occupations, All Other',
    group: 'Computer & Mathematical',
  },

  // 17 — Architecture & Engineering
  { code: '17-1011', title: 'Architects', group: 'Architecture & Engineering' },
  { code: '17-1012', title: 'Landscape Architects', group: 'Architecture & Engineering' },
  {
    code: '17-1021',
    title: 'Cartographers and Photogrammetrists',
    group: 'Architecture & Engineering',
  },
  { code: '17-1022', title: 'Surveyors', group: 'Architecture & Engineering' },
  { code: '17-2011', title: 'Aerospace Engineers', group: 'Architecture & Engineering' },
  { code: '17-2021', title: 'Agricultural Engineers', group: 'Architecture & Engineering' },
  {
    code: '17-2031',
    title: 'Bioengineers and Biomedical Engineers',
    group: 'Architecture & Engineering',
  },
  { code: '17-2041', title: 'Chemical Engineers', group: 'Architecture & Engineering' },
  { code: '17-2051', title: 'Civil Engineers', group: 'Architecture & Engineering' },
  { code: '17-2061', title: 'Computer Hardware Engineers', group: 'Architecture & Engineering' },
  { code: '17-2071', title: 'Electrical Engineers', group: 'Architecture & Engineering' },
  { code: '17-2072', title: 'Electronics Engineers', group: 'Architecture & Engineering' },
  { code: '17-2081', title: 'Environmental Engineers', group: 'Architecture & Engineering' },
  { code: '17-2110', title: 'Industrial Engineers', group: 'Architecture & Engineering' },
  { code: '17-2111', title: 'Health and Safety Engineers', group: 'Architecture & Engineering' },
  { code: '17-2112', title: 'Industrial Engineers', group: 'Architecture & Engineering' },
  {
    code: '17-2121',
    title: 'Marine Engineers and Naval Architects',
    group: 'Architecture & Engineering',
  },
  { code: '17-2131', title: 'Materials Engineers', group: 'Architecture & Engineering' },
  { code: '17-2141', title: 'Mechanical Engineers', group: 'Architecture & Engineering' },
  {
    code: '17-2151',
    title: 'Mining and Geological Engineers',
    group: 'Architecture & Engineering',
  },
  { code: '17-2161', title: 'Nuclear Engineers', group: 'Architecture & Engineering' },
  { code: '17-2171', title: 'Petroleum Engineers', group: 'Architecture & Engineering' },
  { code: '17-2199', title: 'Engineers, All Other', group: 'Architecture & Engineering' },
  {
    code: '17-3011',
    title: 'Architectural and Civil Drafters',
    group: 'Architecture & Engineering',
  },
  {
    code: '17-3012',
    title: 'Electrical and Electronics Drafters',
    group: 'Architecture & Engineering',
  },
  { code: '17-3013', title: 'Mechanical Drafters', group: 'Architecture & Engineering' },
  { code: '17-3019', title: 'Drafters, All Other', group: 'Architecture & Engineering' },
  {
    code: '17-3021',
    title: 'Aerospace Engineering and Operations Technologists',
    group: 'Architecture & Engineering',
  },
  {
    code: '17-3022',
    title: 'Civil Engineering Technologists and Technicians',
    group: 'Architecture & Engineering',
  },
  {
    code: '17-3023',
    title: 'Electrical and Electronic Engineering Technologists',
    group: 'Architecture & Engineering',
  },
  {
    code: '17-3024',
    title: 'Electro-Mechanical and Mechatronics Technologists',
    group: 'Architecture & Engineering',
  },
  {
    code: '17-3025',
    title: 'Environmental Engineering Technologists',
    group: 'Architecture & Engineering',
  },
  {
    code: '17-3026',
    title: 'Industrial Engineering Technologists',
    group: 'Architecture & Engineering',
  },
  {
    code: '17-3027',
    title: 'Mechanical Engineering Technologists',
    group: 'Architecture & Engineering',
  },
  {
    code: '17-3029',
    title: 'Engineering Technologists and Technicians, All Other',
    group: 'Architecture & Engineering',
  },
  {
    code: '17-3031',
    title: 'Surveying and Mapping Technicians',
    group: 'Architecture & Engineering',
  },

  // 19 — Life, Physical & Social Science
  { code: '19-1011', title: 'Animal Scientists', group: 'Life, Physical & Social Science' },
  {
    code: '19-1012',
    title: 'Food Scientists and Technologists',
    group: 'Life, Physical & Social Science',
  },
  { code: '19-1013', title: 'Soil and Plant Scientists', group: 'Life, Physical & Social Science' },
  { code: '19-1020', title: 'Biological Scientists', group: 'Life, Physical & Social Science' },
  {
    code: '19-1021',
    title: 'Biochemists and Biophysicists',
    group: 'Life, Physical & Social Science',
  },
  { code: '19-1022', title: 'Microbiologists', group: 'Life, Physical & Social Science' },
  {
    code: '19-1023',
    title: 'Zoologists and Wildlife Biologists',
    group: 'Life, Physical & Social Science',
  },
  {
    code: '19-1029',
    title: 'Biological Scientists, All Other',
    group: 'Life, Physical & Social Science',
  },
  { code: '19-1031', title: 'Conservation Scientists', group: 'Life, Physical & Social Science' },
  { code: '19-1032', title: 'Foresters', group: 'Life, Physical & Social Science' },
  { code: '19-1041', title: 'Epidemiologists', group: 'Life, Physical & Social Science' },
  { code: '19-1042', title: 'Medical Scientists', group: 'Life, Physical & Social Science' },
  {
    code: '19-1099',
    title: 'Life Scientists, All Other',
    group: 'Life, Physical & Social Science',
  },
  { code: '19-2011', title: 'Astronomers', group: 'Life, Physical & Social Science' },
  { code: '19-2012', title: 'Physicists', group: 'Life, Physical & Social Science' },
  {
    code: '19-2021',
    title: 'Atmospheric and Space Scientists',
    group: 'Life, Physical & Social Science',
  },
  { code: '19-2031', title: 'Chemists', group: 'Life, Physical & Social Science' },
  { code: '19-2032', title: 'Materials Scientists', group: 'Life, Physical & Social Science' },
  {
    code: '19-2041',
    title: 'Environmental Scientists and Specialists',
    group: 'Life, Physical & Social Science',
  },
  { code: '19-2042', title: 'Geoscientists', group: 'Life, Physical & Social Science' },
  { code: '19-2043', title: 'Hydrologists', group: 'Life, Physical & Social Science' },
  {
    code: '19-2099',
    title: 'Physical Scientists, All Other',
    group: 'Life, Physical & Social Science',
  },
  { code: '19-3011', title: 'Economists', group: 'Life, Physical & Social Science' },
  { code: '19-3022', title: 'Survey Researchers', group: 'Life, Physical & Social Science' },
  {
    code: '19-3031',
    title: 'Clinical and Counseling Psychologists',
    group: 'Life, Physical & Social Science',
  },
  {
    code: '19-3032',
    title: 'Industrial-Organizational Psychologists',
    group: 'Life, Physical & Social Science',
  },
  { code: '19-3033', title: 'School Psychologists', group: 'Life, Physical & Social Science' },
  { code: '19-3034', title: 'Research Psychologists', group: 'Life, Physical & Social Science' },
  { code: '19-3041', title: 'Sociologists', group: 'Life, Physical & Social Science' },
  {
    code: '19-3051',
    title: 'Urban and Regional Planners',
    group: 'Life, Physical & Social Science',
  },
  {
    code: '19-3091',
    title: 'Anthropologists and Archeologists',
    group: 'Life, Physical & Social Science',
  },
  { code: '19-3092', title: 'Geographers', group: 'Life, Physical & Social Science' },
  { code: '19-3093', title: 'Historians', group: 'Life, Physical & Social Science' },
  { code: '19-3094', title: 'Political Scientists', group: 'Life, Physical & Social Science' },
  {
    code: '19-3099',
    title: 'Social Scientists and Related Workers, All Other',
    group: 'Life, Physical & Social Science',
  },
  {
    code: '19-4010',
    title: 'Agricultural and Food Science Technicians',
    group: 'Life, Physical & Social Science',
  },
  { code: '19-4021', title: 'Biological Technicians', group: 'Life, Physical & Social Science' },
  { code: '19-4031', title: 'Chemical Technicians', group: 'Life, Physical & Social Science' },
  { code: '19-4051', title: 'Nuclear Technicians', group: 'Life, Physical & Social Science' },
  {
    code: '19-4061',
    title: 'Social Science Research Assistants',
    group: 'Life, Physical & Social Science',
  },
  {
    code: '19-4099',
    title: 'Life, Physical, and Social Science Technicians, All Other',
    group: 'Life, Physical & Social Science',
  },

  // 21 — Community & Social Service
  {
    code: '21-1011',
    title: 'Substance Abuse, Behavioral Disorder Counselors',
    group: 'Community & Social Service',
  },
  {
    code: '21-1012',
    title: 'Educational, Guidance, and Career Counselors',
    group: 'Community & Social Service',
  },
  { code: '21-1013', title: 'Marriage and Family Therapists', group: 'Community & Social Service' },
  { code: '21-1014', title: 'Mental Health Counselors', group: 'Community & Social Service' },
  { code: '21-1015', title: 'Rehabilitation Counselors', group: 'Community & Social Service' },
  { code: '21-1019', title: 'Counselors, All Other', group: 'Community & Social Service' },
  {
    code: '21-1021',
    title: 'Child, Family, and School Social Workers',
    group: 'Community & Social Service',
  },
  { code: '21-1022', title: 'Healthcare Social Workers', group: 'Community & Social Service' },
  {
    code: '21-1023',
    title: 'Mental Health and Substance Abuse Social Workers',
    group: 'Community & Social Service',
  },
  { code: '21-1029', title: 'Social Workers, All Other', group: 'Community & Social Service' },
  { code: '21-1091', title: 'Health Education Specialists', group: 'Community & Social Service' },
  {
    code: '21-1092',
    title: 'Probation Officers and Correctional Treatment Specialists',
    group: 'Community & Social Service',
  },
  {
    code: '21-1093',
    title: 'Social and Human Service Assistants',
    group: 'Community & Social Service',
  },
  { code: '21-1094', title: 'Community Health Workers', group: 'Community & Social Service' },
  { code: '21-2011', title: 'Clergy', group: 'Community & Social Service' },
  {
    code: '21-2021',
    title: 'Directors, Religious Activities and Education',
    group: 'Community & Social Service',
  },
  { code: '21-2099', title: 'Religious Workers, All Other', group: 'Community & Social Service' },

  // 23 — Legal
  { code: '23-1011', title: 'Lawyers', group: 'Legal' },
  { code: '23-1012', title: 'Judicial Law Clerks', group: 'Legal' },
  { code: '23-1021', title: 'Administrative Law Judges, Adjudicators', group: 'Legal' },
  { code: '23-1022', title: 'Arbitrators, Mediators, and Conciliators', group: 'Legal' },
  { code: '23-1023', title: 'Judges, Magistrate Judges, and Magistrates', group: 'Legal' },
  { code: '23-2011', title: 'Paralegals and Legal Assistants', group: 'Legal' },
  { code: '23-2031', title: 'Legal Support Workers, All Other', group: 'Legal' },
  { code: '23-2093', title: 'Title Examiners, Abstractors, and Searchers', group: 'Legal' },
  { code: '23-2099', title: 'Legal Support Workers, All Other', group: 'Legal' },

  // 25 — Education, Training & Library
  { code: '25-1011', title: 'Business Teachers, Postsecondary', group: 'Education & Training' },
  {
    code: '25-1021',
    title: 'Computer Science Teachers, Postsecondary',
    group: 'Education & Training',
  },
  {
    code: '25-1022',
    title: 'Mathematical Science Teachers, Postsecondary',
    group: 'Education & Training',
  },
  { code: '25-1031', title: 'Architecture Teachers, Postsecondary', group: 'Education & Training' },
  { code: '25-1032', title: 'Engineering Teachers, Postsecondary', group: 'Education & Training' },
  {
    code: '25-1041',
    title: 'Agricultural Sciences Teachers, Postsecondary',
    group: 'Education & Training',
  },
  {
    code: '25-1042',
    title: 'Biological Science Teachers, Postsecondary',
    group: 'Education & Training',
  },
  {
    code: '25-1043',
    title: 'Forestry and Conservation Science Teachers, Postsecondary',
    group: 'Education & Training',
  },
  {
    code: '25-1051',
    title: 'Atmospheric, Earth, Marine, and Space Sciences Teachers',
    group: 'Education & Training',
  },
  { code: '25-1052', title: 'Chemistry Teachers, Postsecondary', group: 'Education & Training' },
  {
    code: '25-1053',
    title: 'Environmental Science Teachers, Postsecondary',
    group: 'Education & Training',
  },
  { code: '25-1054', title: 'Physics Teachers, Postsecondary', group: 'Education & Training' },
  {
    code: '25-1061',
    title: 'Anthropology and Archeology Teachers, Postsecondary',
    group: 'Education & Training',
  },
  {
    code: '25-1062',
    title: 'Area, Ethnic, and Cultural Studies Teachers, Postsecondary',
    group: 'Education & Training',
  },
  { code: '25-1063', title: 'Economics Teachers, Postsecondary', group: 'Education & Training' },
  { code: '25-1064', title: 'Geography Teachers, Postsecondary', group: 'Education & Training' },
  {
    code: '25-1065',
    title: 'Political Science Teachers, Postsecondary',
    group: 'Education & Training',
  },
  { code: '25-1066', title: 'Psychology Teachers, Postsecondary', group: 'Education & Training' },
  { code: '25-1067', title: 'Sociology Teachers, Postsecondary', group: 'Education & Training' },
  {
    code: '25-1069',
    title: 'Social Sciences Teachers, Postsecondary, All Other',
    group: 'Education & Training',
  },
  {
    code: '25-1071',
    title: 'Health Specialties Teachers, Postsecondary',
    group: 'Education & Training',
  },
  {
    code: '25-1072',
    title: 'Nursing Instructors and Teachers, Postsecondary',
    group: 'Education & Training',
  },
  { code: '25-1081', title: 'Education Teachers, Postsecondary', group: 'Education & Training' },
  {
    code: '25-1082',
    title: 'Library Science Teachers, Postsecondary',
    group: 'Education & Training',
  },
  {
    code: '25-1111',
    title: 'Criminal Justice and Law Enforcement Teachers',
    group: 'Education & Training',
  },
  { code: '25-1112', title: 'Law Teachers, Postsecondary', group: 'Education & Training' },
  { code: '25-1113', title: 'Social Work Teachers, Postsecondary', group: 'Education & Training' },
  {
    code: '25-1121',
    title: 'Art, Drama, and Music Teachers, Postsecondary',
    group: 'Education & Training',
  },
  {
    code: '25-1122',
    title: 'Communications Teachers, Postsecondary',
    group: 'Education & Training',
  },
  {
    code: '25-1123',
    title: 'English Language and Literature Teachers, Postsecondary',
    group: 'Education & Training',
  },
  {
    code: '25-1124',
    title: 'Foreign Language and Literature Teachers, Postsecondary',
    group: 'Education & Training',
  },
  { code: '25-1125', title: 'History Teachers, Postsecondary', group: 'Education & Training' },
  {
    code: '25-1126',
    title: 'Philosophy and Religion Teachers, Postsecondary',
    group: 'Education & Training',
  },
  { code: '25-1191', title: 'Graduate Teaching Assistants', group: 'Education & Training' },
  {
    code: '25-1199',
    title: 'Postsecondary Teachers, All Other',
    group: 'Education & Training',
    aliases: ['Professor', 'Lecturer', 'College Professor', 'Adjunct Professor', 'Instructor'],
  },
  { code: '25-2011', title: 'Preschool Teachers', group: 'Education & Training' },
  { code: '25-2012', title: 'Kindergarten Teachers', group: 'Education & Training' },
  {
    code: '25-2021',
    title: 'Elementary School Teachers',
    group: 'Education & Training',
    aliases: [
      'Elementary Teacher',
      'Grade School Teacher',
      'Primary School Teacher',
      'K-5 Teacher',
    ],
  },
  { code: '25-2022', title: 'Middle School Teachers', group: 'Education & Training' },
  {
    code: '25-2023',
    title: 'Career and Technical Education Teachers, Middle School',
    group: 'Education & Training',
  },
  { code: '25-2031', title: 'Secondary School Teachers', group: 'Education & Training' },
  {
    code: '25-2032',
    title: 'Career and Technical Education Teachers, Secondary School',
    group: 'Education & Training',
  },
  { code: '25-2050', title: 'Special Education Teachers', group: 'Education & Training' },
  {
    code: '25-3011',
    title: 'Adult Basic Education, Adult Secondary Education Teachers',
    group: 'Education & Training',
  },
  { code: '25-3021', title: 'Self-Enrichment Teachers', group: 'Education & Training' },
  { code: '25-3031', title: 'Substitute Teachers', group: 'Education & Training' },
  { code: '25-3041', title: 'Tutors', group: 'Education & Training' },
  { code: '25-4011', title: 'Archivists', group: 'Education & Training' },
  { code: '25-4012', title: 'Curators', group: 'Education & Training' },
  { code: '25-4013', title: 'Museum Technicians and Conservators', group: 'Education & Training' },
  {
    code: '25-4021',
    title: 'Librarians and Media Collections Specialists',
    group: 'Education & Training',
  },
  { code: '25-4031', title: 'Library Technicians', group: 'Education & Training' },
  {
    code: '25-9011',
    title: 'Audio-Visual and Multimedia Collections Specialists',
    group: 'Education & Training',
  },
  { code: '25-9031', title: 'Instructional Coordinators', group: 'Education & Training' },
  { code: '25-9041', title: 'Teacher Assistants', group: 'Education & Training' },
  {
    code: '25-9099',
    title: 'Educational Instruction and Library Workers, All Other',
    group: 'Education & Training',
  },

  // 27 — Arts, Design, Entertainment, Sports & Media
  { code: '27-1011', title: 'Art Directors', group: 'Arts, Design & Media' },
  { code: '27-1012', title: 'Craft Artists', group: 'Arts, Design & Media' },
  {
    code: '27-1013',
    title: 'Fine Artists, Including Painters, Sculptors, and Illustrators',
    group: 'Arts, Design & Media',
  },
  {
    code: '27-1014',
    title: 'Special Effects Artists and Animators',
    group: 'Arts, Design & Media',
  },
  {
    code: '27-1019',
    title: 'Artists and Related Workers, All Other',
    group: 'Arts, Design & Media',
  },
  { code: '27-1021', title: 'Commercial and Industrial Designers', group: 'Arts, Design & Media' },
  { code: '27-1022', title: 'Fashion Designers', group: 'Arts, Design & Media' },
  { code: '27-1023', title: 'Floral Designers', group: 'Arts, Design & Media' },
  { code: '27-1024', title: 'Graphic Designers', group: 'Arts, Design & Media' },
  { code: '27-1025', title: 'Interior Designers', group: 'Arts, Design & Media' },
  {
    code: '27-1026',
    title: 'Merchandise Displayers and Window Trimmers',
    group: 'Arts, Design & Media',
  },
  { code: '27-1027', title: 'Set and Exhibit Designers', group: 'Arts, Design & Media' },
  { code: '27-1029', title: 'Designers, All Other', group: 'Arts, Design & Media' },
  { code: '27-2011', title: 'Actors', group: 'Arts, Design & Media' },
  { code: '27-2012', title: 'Producers and Directors', group: 'Arts, Design & Media' },
  { code: '27-2021', title: 'Athletes and Sports Competitors', group: 'Arts, Design & Media' },
  { code: '27-2022', title: 'Coaches and Scouts', group: 'Arts, Design & Media' },
  {
    code: '27-2023',
    title: 'Umpires, Referees, and Other Sports Officials',
    group: 'Arts, Design & Media',
  },
  { code: '27-2031', title: 'Dancers', group: 'Arts, Design & Media' },
  { code: '27-2032', title: 'Choreographers', group: 'Arts, Design & Media' },
  { code: '27-2041', title: 'Music Directors and Composers', group: 'Arts, Design & Media' },
  { code: '27-2042', title: 'Musicians and Singers', group: 'Arts, Design & Media' },
  {
    code: '27-2099',
    title: 'Entertainers and Performers, All Other',
    group: 'Arts, Design & Media',
  },
  {
    code: '27-3011',
    title: 'Broadcast Announcers and Radio Disc Jockeys',
    group: 'Arts, Design & Media',
  },
  {
    code: '27-3021',
    title: 'News Analysts, Reporters, and Journalists',
    group: 'Arts, Design & Media',
  },
  { code: '27-3022', title: 'Editors', group: 'Arts, Design & Media' },
  {
    code: '27-3023',
    title: 'News Analysts, Reporters, and Journalists',
    group: 'Arts, Design & Media',
  },
  { code: '27-3031', title: 'Public Relations Specialists', group: 'Arts, Design & Media' },
  { code: '27-3041', title: 'Editors', group: 'Arts, Design & Media' },
  { code: '27-3042', title: 'Technical Writers', group: 'Arts, Design & Media' },
  { code: '27-3043', title: 'Writers and Authors', group: 'Arts, Design & Media' },
  { code: '27-3091', title: 'Interpreters and Translators', group: 'Arts, Design & Media' },
  {
    code: '27-3092',
    title: 'Court Reporters and Simultaneous Captioners',
    group: 'Arts, Design & Media',
  },
  {
    code: '27-3099',
    title: 'Media and Communication Workers, All Other',
    group: 'Arts, Design & Media',
  },
  { code: '27-4011', title: 'Audio and Video Technicians', group: 'Arts, Design & Media' },
  { code: '27-4012', title: 'Broadcast Technicians', group: 'Arts, Design & Media' },
  { code: '27-4013', title: 'Radio Operators', group: 'Arts, Design & Media' },
  { code: '27-4014', title: 'Sound Engineering Technicians', group: 'Arts, Design & Media' },
  { code: '27-4021', title: 'Photographers', group: 'Arts, Design & Media' },
  {
    code: '27-4031',
    title: 'Camera Operators, Television, Video, and Film',
    group: 'Arts, Design & Media',
  },
  { code: '27-4032', title: 'Film and Video Editors', group: 'Arts, Design & Media' },
  {
    code: '27-4099',
    title: 'Media and Communication Equipment Workers, All Other',
    group: 'Arts, Design & Media',
  },

  // 29 — Healthcare Practitioners
  { code: '29-1011', title: 'Chiropractors', group: 'Healthcare Practitioners' },
  { code: '29-1021', title: 'Dentists, General', group: 'Healthcare Practitioners' },
  { code: '29-1031', title: 'Dietitians and Nutritionists', group: 'Healthcare Practitioners' },
  { code: '29-1041', title: 'Optometrists', group: 'Healthcare Practitioners' },
  { code: '29-1051', title: 'Pharmacists', group: 'Healthcare Practitioners' },
  {
    code: '29-1071',
    title: 'Physician Assistants',
    group: 'Healthcare Practitioners',
    aliases: ['PA', 'PA-C', 'Physician Associate'],
  },
  { code: '29-1081', title: 'Podiatrists', group: 'Healthcare Practitioners' },
  { code: '29-1122', title: 'Occupational Therapists', group: 'Healthcare Practitioners' },
  { code: '29-1123', title: 'Physical Therapists', group: 'Healthcare Practitioners' },
  { code: '29-1124', title: 'Radiation Therapists', group: 'Healthcare Practitioners' },
  { code: '29-1125', title: 'Recreational Therapists', group: 'Healthcare Practitioners' },
  { code: '29-1126', title: 'Respiratory Therapists', group: 'Healthcare Practitioners' },
  { code: '29-1127', title: 'Speech-Language Pathologists', group: 'Healthcare Practitioners' },
  { code: '29-1128', title: 'Exercise Physiologists', group: 'Healthcare Practitioners' },
  {
    code: '29-1141',
    title: 'Registered Nurses',
    group: 'Healthcare Practitioners',
    aliases: ['RN', 'Nurse', 'Staff Nurse', 'ICU Nurse', 'ER Nurse'],
  },
  { code: '29-1151', title: 'Nurse Anesthetists', group: 'Healthcare Practitioners' },
  { code: '29-1161', title: 'Nurse Midwives', group: 'Healthcare Practitioners' },
  { code: '29-1171', title: 'Nurse Practitioners', group: 'Healthcare Practitioners' },
  { code: '29-1181', title: 'Audiologists', group: 'Healthcare Practitioners' },
  { code: '29-1211', title: 'Anesthesiologists', group: 'Healthcare Practitioners' },
  { code: '29-1212', title: 'Cardiologists', group: 'Healthcare Practitioners' },
  { code: '29-1213', title: 'Dermatologists', group: 'Healthcare Practitioners' },
  { code: '29-1214', title: 'Emergency Medicine Physicians', group: 'Healthcare Practitioners' },
  {
    code: '29-1215',
    title: 'Family Medicine Physicians',
    group: 'Healthcare Practitioners',
    aliases: [
      'Doctor',
      'Physician',
      'GP',
      'General Practitioner',
      'Primary Care Physician',
      'PCP',
      'MD',
    ],
  },
  {
    code: '29-1216',
    title: 'General Internal Medicine Physicians',
    group: 'Healthcare Practitioners',
  },
  { code: '29-1217', title: 'Neurologists', group: 'Healthcare Practitioners' },
  { code: '29-1218', title: 'Obstetricians and Gynecologists', group: 'Healthcare Practitioners' },
  { code: '29-1221', title: 'Pediatricians, General', group: 'Healthcare Practitioners' },
  { code: '29-1222', title: 'Physicians, Pathologists', group: 'Healthcare Practitioners' },
  { code: '29-1223', title: 'Psychiatrists', group: 'Healthcare Practitioners' },
  { code: '29-1224', title: 'Radiologists', group: 'Healthcare Practitioners' },
  { code: '29-1229', title: 'Physicians, All Other', group: 'Healthcare Practitioners' },
  { code: '29-1292', title: 'Dental Hygienists', group: 'Healthcare Practitioners' },
  {
    code: '29-1299',
    title: 'Healthcare Practitioners, All Other',
    group: 'Healthcare Practitioners',
  },
  {
    code: '29-2010',
    title: 'Clinical Laboratory Technologists and Technicians',
    group: 'Healthcare Practitioners',
  },
  { code: '29-2021', title: 'Dental Assistants', group: 'Healthcare Practitioners' },
  {
    code: '29-2031',
    title: 'Cardiovascular Technologists and Technicians',
    group: 'Healthcare Practitioners',
  },
  { code: '29-2032', title: 'Diagnostic Medical Sonographers', group: 'Healthcare Practitioners' },
  { code: '29-2033', title: 'Nuclear Medicine Technologists', group: 'Healthcare Practitioners' },
  { code: '29-2034', title: 'Radiologic Technologists', group: 'Healthcare Practitioners' },
  {
    code: '29-2035',
    title: 'Magnetic Resonance Imaging Technologists',
    group: 'Healthcare Practitioners',
  },
  { code: '29-2041', title: 'Emergency Medical Technicians', group: 'Healthcare Practitioners' },
  { code: '29-2042', title: 'Paramedics', group: 'Healthcare Practitioners' },
  { code: '29-2043', title: 'Paramedics', group: 'Healthcare Practitioners' },
  { code: '29-2051', title: 'Dietetic Technicians', group: 'Healthcare Practitioners' },
  { code: '29-2053', title: 'Psychiatric Technicians', group: 'Healthcare Practitioners' },
  { code: '29-2055', title: 'Surgical Technologists', group: 'Healthcare Practitioners' },
  {
    code: '29-2056',
    title: 'Veterinary Technologists and Technicians',
    group: 'Healthcare Practitioners',
  },
  { code: '29-2057', title: 'Ophthalmic Medical Technicians', group: 'Healthcare Practitioners' },
  {
    code: '29-2061',
    title: 'Licensed Practical and Licensed Vocational Nurses',
    group: 'Healthcare Practitioners',
    aliases: ['LPN', 'LVN', 'Licensed Practical Nurse', 'Licensed Vocational Nurse'],
  },
  { code: '29-2071', title: 'Medical Records Specialists', group: 'Healthcare Practitioners' },
  { code: '29-2081', title: 'Opticians, Dispensing', group: 'Healthcare Practitioners' },
  { code: '29-2091', title: 'Orthotists and Prosthetists', group: 'Healthcare Practitioners' },
  {
    code: '29-2099',
    title: 'Health Technologists and Technicians, All Other',
    group: 'Healthcare Practitioners',
  },

  // 31 — Healthcare Support
  { code: '31-1120', title: 'Home Health and Personal Care Aides', group: 'Healthcare Support' },
  { code: '31-1131', title: 'Nursing Assistants', group: 'Healthcare Support' },
  { code: '31-1132', title: 'Orderlies', group: 'Healthcare Support' },
  { code: '31-1133', title: 'Psychiatric Aides', group: 'Healthcare Support' },
  { code: '31-2011', title: 'Occupational Therapy Assistants', group: 'Healthcare Support' },
  { code: '31-2012', title: 'Occupational Therapy Aides', group: 'Healthcare Support' },
  { code: '31-2021', title: 'Physical Therapist Assistants', group: 'Healthcare Support' },
  { code: '31-2022', title: 'Physical Therapist Aides', group: 'Healthcare Support' },
  { code: '31-9011', title: 'Massage Therapists', group: 'Healthcare Support' },
  { code: '31-9091', title: 'Dental Assistants', group: 'Healthcare Support' },
  { code: '31-9092', title: 'Medical Assistants', group: 'Healthcare Support' },
  { code: '31-9093', title: 'Medical Equipment Preparers', group: 'Healthcare Support' },
  { code: '31-9094', title: 'Medical Transcriptionists', group: 'Healthcare Support' },
  { code: '31-9095', title: 'Pharmacy Aides', group: 'Healthcare Support' },
  {
    code: '31-9096',
    title: 'Veterinary Assistants and Laboratory Animal Caretakers',
    group: 'Healthcare Support',
  },
  { code: '31-9097', title: 'Phlebotomists', group: 'Healthcare Support' },
  { code: '31-9099', title: 'Healthcare Support Workers, All Other', group: 'Healthcare Support' },

  // 33 — Protective Service
  {
    code: '33-1011',
    title: 'First-Line Supervisors of Correctional Officers',
    group: 'Protective Service',
  },
  {
    code: '33-1012',
    title: 'First-Line Supervisors of Police and Detectives',
    group: 'Protective Service',
  },
  {
    code: '33-1021',
    title: 'First-Line Supervisors of Fire Fighting and Prevention Workers',
    group: 'Protective Service',
  },
  { code: '33-2011', title: 'Firefighters', group: 'Protective Service' },
  { code: '33-2021', title: 'Fire Inspectors and Investigators', group: 'Protective Service' },
  { code: '33-3011', title: 'Bailiffs', group: 'Protective Service' },
  { code: '33-3012', title: 'Correctional Officers and Jailers', group: 'Protective Service' },
  { code: '33-3021', title: 'Detectives and Criminal Investigators', group: 'Protective Service' },
  { code: '33-3031', title: 'Fish and Game Wardens', group: 'Protective Service' },
  { code: '33-3041', title: 'Parking Enforcement Workers', group: 'Protective Service' },
  { code: '33-3051', title: 'Police and Sheriff Patrol Officers', group: 'Protective Service' },
  { code: '33-3052', title: 'Transit and Railroad Police', group: 'Protective Service' },
  { code: '33-9011', title: 'Animal Control Workers', group: 'Protective Service' },
  { code: '33-9021', title: 'Private Detectives and Investigators', group: 'Protective Service' },
  {
    code: '33-9031',
    title: 'Gambling Surveillance Officers and Gaming Investigators',
    group: 'Protective Service',
  },
  {
    code: '33-9032',
    title: 'Security Guards and Casino Surveillance Officers',
    group: 'Protective Service',
  },
  { code: '33-9091', title: 'Crossing Guards and Flaggers', group: 'Protective Service' },
  { code: '33-9093', title: 'Transportation Security Screeners', group: 'Protective Service' },
  { code: '33-9099', title: 'Protective Service Workers, All Other', group: 'Protective Service' },

  // 35 — Food Preparation & Serving
  { code: '35-1011', title: 'Chefs and Head Cooks', group: 'Food Preparation & Serving' },
  {
    code: '35-1012',
    title: 'First-Line Supervisors of Food Preparation Workers',
    group: 'Food Preparation & Serving',
  },
  { code: '35-2011', title: 'Cooks, Fast Food', group: 'Food Preparation & Serving' },
  {
    code: '35-2012',
    title: 'Cooks, Institution and Cafeteria',
    group: 'Food Preparation & Serving',
  },
  { code: '35-2013', title: 'Cooks, Private Household', group: 'Food Preparation & Serving' },
  { code: '35-2014', title: 'Cooks, Restaurant', group: 'Food Preparation & Serving' },
  { code: '35-2015', title: 'Cooks, Short Order', group: 'Food Preparation & Serving' },
  { code: '35-2019', title: 'Cooks, All Other', group: 'Food Preparation & Serving' },
  { code: '35-2021', title: 'Food Preparation Workers', group: 'Food Preparation & Serving' },
  { code: '35-3011', title: 'Bartenders', group: 'Food Preparation & Serving' },
  { code: '35-3023', title: 'Fast Food and Counter Workers', group: 'Food Preparation & Serving' },
  { code: '35-3031', title: 'Waiters and Waitresses', group: 'Food Preparation & Serving' },
  { code: '35-3041', title: 'Food Servers, Nonrestaurant', group: 'Food Preparation & Serving' },
  {
    code: '35-9011',
    title: 'Dining Room and Cafeteria Attendants and Bartender Helpers',
    group: 'Food Preparation & Serving',
  },
  { code: '35-9021', title: 'Dishwashers', group: 'Food Preparation & Serving' },
  { code: '35-9031', title: 'Hosts and Hostesses', group: 'Food Preparation & Serving' },
  {
    code: '35-9099',
    title: 'Food Preparation and Serving Related Workers, All Other',
    group: 'Food Preparation & Serving',
  },

  // 37 — Building & Grounds Cleaning
  {
    code: '37-1011',
    title: 'First-Line Supervisors of Housekeeping and Janitorial Workers',
    group: 'Building & Grounds Cleaning',
  },
  {
    code: '37-1012',
    title: 'First-Line Supervisors of Landscaping, Lawn Service Workers',
    group: 'Building & Grounds Cleaning',
  },
  { code: '37-2011', title: 'Janitors and Cleaners', group: 'Building & Grounds Cleaning' },
  {
    code: '37-2012',
    title: 'Maids and Housekeeping Cleaners',
    group: 'Building & Grounds Cleaning',
  },
  {
    code: '37-2019',
    title: 'Building Cleaning Workers, All Other',
    group: 'Building & Grounds Cleaning',
  },
  { code: '37-2021', title: 'Pest Control Workers', group: 'Building & Grounds Cleaning' },
  {
    code: '37-3011',
    title: 'Landscaping and Groundskeeping Workers',
    group: 'Building & Grounds Cleaning',
  },
  {
    code: '37-3012',
    title: 'Pesticide Handlers, Sprayers, and Applicators',
    group: 'Building & Grounds Cleaning',
  },
  { code: '37-3013', title: 'Tree Trimmers and Pruners', group: 'Building & Grounds Cleaning' },
  {
    code: '37-3019',
    title: 'Grounds Maintenance Workers, All Other',
    group: 'Building & Grounds Cleaning',
  },

  // 39 — Personal Care & Service
  {
    code: '39-1010',
    title: 'First-Line Supervisors of Personal Service Workers',
    group: 'Personal Care & Service',
  },
  { code: '39-2011', title: 'Animal Trainers', group: 'Personal Care & Service' },
  { code: '39-2021', title: 'Animal Caretakers', group: 'Personal Care & Service' },
  { code: '39-3011', title: 'Gambling Dealers', group: 'Personal Care & Service' },
  { code: '39-3021', title: 'Motion Picture Projectionists', group: 'Personal Care & Service' },
  {
    code: '39-3031',
    title: 'Ushers, Lobby Attendants, and Ticket Takers',
    group: 'Personal Care & Service',
  },
  {
    code: '39-3091',
    title: 'Amusement and Recreation Attendants',
    group: 'Personal Care & Service',
  },
  { code: '39-3092', title: 'Costume Attendants', group: 'Personal Care & Service' },
  {
    code: '39-3093',
    title: 'Locker Room, Coatroom, and Dressing Room Attendants',
    group: 'Personal Care & Service',
  },
  { code: '39-4011', title: 'Embalmers', group: 'Personal Care & Service' },
  { code: '39-4012', title: 'Crematory Operators', group: 'Personal Care & Service' },
  { code: '39-4021', title: 'Funeral Attendants', group: 'Personal Care & Service' },
  {
    code: '39-4031',
    title: 'Morticians, Undertakers, and Funeral Arrangers',
    group: 'Personal Care & Service',
  },
  { code: '39-5011', title: 'Barbers', group: 'Personal Care & Service' },
  {
    code: '39-5012',
    title: 'Hairdressers, Hairstylists, and Cosmetologists',
    group: 'Personal Care & Service',
  },
  { code: '39-5013', title: 'Manicurists and Pedicurists', group: 'Personal Care & Service' },
  {
    code: '39-5091',
    title: 'Makeup Artists, Theatrical and Performance',
    group: 'Personal Care & Service',
  },
  { code: '39-5092', title: 'Skin Care Specialists', group: 'Personal Care & Service' },
  { code: '39-6011', title: 'Baggage Porters and Bellhops', group: 'Personal Care & Service' },
  { code: '39-6012', title: 'Concierges', group: 'Personal Care & Service' },
  { code: '39-7011', title: 'Tour and Travel Guides', group: 'Personal Care & Service' },
  { code: '39-7012', title: 'Travel Guides', group: 'Personal Care & Service' },
  { code: '39-9011', title: 'Childcare Workers', group: 'Personal Care & Service' },
  {
    code: '39-9021',
    title: 'Exercise Trainers and Group Fitness Instructors',
    group: 'Personal Care & Service',
  },
  { code: '39-9031', title: 'Recreation Workers', group: 'Personal Care & Service' },
  { code: '39-9032', title: 'Recreation Workers', group: 'Personal Care & Service' },
  { code: '39-9041', title: 'Residential Advisors', group: 'Personal Care & Service' },
  {
    code: '39-9099',
    title: 'Personal Care and Service Workers, All Other',
    group: 'Personal Care & Service',
  },

  // 41 — Sales & Related
  {
    code: '41-1011',
    title: 'First-Line Supervisors of Retail Sales Workers',
    group: 'Sales & Related',
  },
  {
    code: '41-1012',
    title: 'First-Line Supervisors of Non-Retail Sales Workers',
    group: 'Sales & Related',
  },
  { code: '41-2011', title: 'Cashiers', group: 'Sales & Related' },
  { code: '41-2021', title: 'Counter and Rental Clerks', group: 'Sales & Related' },
  { code: '41-2022', title: 'Parts Salespersons', group: 'Sales & Related' },
  { code: '41-2031', title: 'Retail Salespersons', group: 'Sales & Related' },
  { code: '41-3011', title: 'Advertising Sales Agents', group: 'Sales & Related' },
  {
    code: '41-3021',
    title: 'Insurance Sales Agents',
    group: 'Sales & Related',
    aliases: ['Insurance Agent', 'Insurance Broker', 'Insurance Advisor'],
  },
  {
    code: '41-3031',
    title: 'Securities, Commodities, and Financial Services Sales Agents',
    group: 'Sales & Related',
  },
  { code: '41-3041', title: 'Travel Agents', group: 'Sales & Related' },
  { code: '41-3091', title: 'Sales Representatives of Services', group: 'Sales & Related' },
  {
    code: '41-4011',
    title: 'Sales Representatives, Wholesale and Manufacturing',
    group: 'Sales & Related',
  },
  { code: '41-9011', title: 'Demonstrators and Product Promoters', group: 'Sales & Related' },
  { code: '41-9012', title: 'Models', group: 'Sales & Related' },
  { code: '41-9021', title: 'Real Estate Brokers', group: 'Sales & Related' },
  { code: '41-9022', title: 'Real Estate Sales Agents', group: 'Sales & Related' },
  { code: '41-9031', title: 'Sales Engineers', group: 'Sales & Related' },
  { code: '41-9041', title: 'Telemarketers', group: 'Sales & Related' },
  {
    code: '41-9091',
    title: 'Door-to-Door Sales Workers, News and Street Vendors',
    group: 'Sales & Related',
  },
  { code: '41-9099', title: 'Sales and Related Workers, All Other', group: 'Sales & Related' },

  // 43 — Office & Administrative Support
  {
    code: '43-1011',
    title: 'First-Line Supervisors of Office and Administrative Support Workers',
    group: 'Office & Administrative Support',
  },
  { code: '43-2011', title: 'Switchboard Operators', group: 'Office & Administrative Support' },
  { code: '43-2021', title: 'Telephone Operators', group: 'Office & Administrative Support' },
  {
    code: '43-3011',
    title: 'Bill and Account Collectors',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-3021',
    title: 'Billing and Posting Clerks',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-3031',
    title: 'Bookkeeping, Accounting, and Auditing Clerks',
    group: 'Office & Administrative Support',
  },
  { code: '43-3041', title: 'Gambling Cage Workers', group: 'Office & Administrative Support' },
  {
    code: '43-3051',
    title: 'Payroll and Timekeeping Clerks',
    group: 'Office & Administrative Support',
  },
  { code: '43-3061', title: 'Procurement Clerks', group: 'Office & Administrative Support' },
  { code: '43-3071', title: 'Tellers', group: 'Office & Administrative Support' },
  { code: '43-4011', title: 'Brokerage Clerks', group: 'Office & Administrative Support' },
  { code: '43-4021', title: 'Correspondence Clerks', group: 'Office & Administrative Support' },
  {
    code: '43-4031',
    title: 'Court, Municipal, and License Clerks',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-4041',
    title: 'Credit Authorizers, Checkers, and Clerks',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-4051',
    title: 'Customer Service Representatives',
    group: 'Office & Administrative Support',
  },
  { code: '43-4061', title: 'Eligibility Interviewers', group: 'Office & Administrative Support' },
  { code: '43-4071', title: 'File Clerks', group: 'Office & Administrative Support' },
  {
    code: '43-4081',
    title: 'Hotel, Motel, and Resort Desk Clerks',
    group: 'Office & Administrative Support',
  },
  { code: '43-4111', title: 'Interviewers', group: 'Office & Administrative Support' },
  {
    code: '43-4121',
    title: 'Library Assistants, Clerical',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-4131',
    title: 'Loan Interviewers and Clerks',
    group: 'Office & Administrative Support',
  },
  { code: '43-4141', title: 'New Accounts Clerks', group: 'Office & Administrative Support' },
  { code: '43-4151', title: 'Order Clerks', group: 'Office & Administrative Support' },
  {
    code: '43-4161',
    title: 'Human Resources Assistants',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-4171',
    title: 'Receptionists and Information Clerks',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-4181',
    title: 'Reservation and Transportation Ticket Agents',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-4199',
    title: 'Information and Record Clerks, All Other',
    group: 'Office & Administrative Support',
  },
  { code: '43-5011', title: 'Cargo and Freight Agents', group: 'Office & Administrative Support' },
  { code: '43-5021', title: 'Couriers and Messengers', group: 'Office & Administrative Support' },
  {
    code: '43-5031',
    title: 'Public Safety Telecommunicators',
    group: 'Office & Administrative Support',
  },
  { code: '43-5032', title: 'Dispatchers', group: 'Office & Administrative Support' },
  { code: '43-5041', title: 'Meter Readers, Utilities', group: 'Office & Administrative Support' },
  { code: '43-5051', title: 'Postal Service Clerks', group: 'Office & Administrative Support' },
  {
    code: '43-5052',
    title: 'Postal Service Mail Carriers',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-5053',
    title: 'Postal Service Mail Sorters, Processors',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-5061',
    title: 'Production, Planning, and Expediting Clerks',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-5071',
    title: 'Shipping, Receiving, and Inventory Clerks',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-5111',
    title: 'Weighers, Measurers, Checkers, and Samplers',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-6011',
    title: 'Executive Secretaries and Executive Administrative Assistants',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-6012',
    title: 'Legal Secretaries and Administrative Assistants',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-6013',
    title: 'Medical Secretaries and Administrative Assistants',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-6014',
    title: 'Secretaries and Administrative Assistants',
    group: 'Office & Administrative Support',
  },
  { code: '43-9011', title: 'Computer Operators', group: 'Office & Administrative Support' },
  { code: '43-9021', title: 'Data Entry Keyers', group: 'Office & Administrative Support' },
  {
    code: '43-9022',
    title: 'Word Processors and Typists',
    group: 'Office & Administrative Support',
  },
  { code: '43-9031', title: 'Desktop Publishers', group: 'Office & Administrative Support' },
  {
    code: '43-9041',
    title: 'Insurance Claims and Policy Processing Clerks',
    group: 'Office & Administrative Support',
  },
  {
    code: '43-9051',
    title: 'Mail Clerks and Mail Machine Operators',
    group: 'Office & Administrative Support',
  },
  { code: '43-9061', title: 'Office Clerks, General', group: 'Office & Administrative Support' },
  { code: '43-9071', title: 'Office Machine Operators', group: 'Office & Administrative Support' },
  {
    code: '43-9081',
    title: 'Proofreaders and Copy Markers',
    group: 'Office & Administrative Support',
  },
  { code: '43-9111', title: 'Statistical Assistants', group: 'Office & Administrative Support' },
  {
    code: '43-9199',
    title: 'Office and Administrative Support Workers, All Other',
    group: 'Office & Administrative Support',
  },

  // 45 — Farming, Fishing & Forestry
  {
    code: '45-1011',
    title: 'First-Line Supervisors of Farming, Fishing, and Forestry Workers',
    group: 'Farming, Fishing & Forestry',
  },
  { code: '45-2011', title: 'Agricultural Inspectors', group: 'Farming, Fishing & Forestry' },
  { code: '45-2021', title: 'Animal Breeders', group: 'Farming, Fishing & Forestry' },
  {
    code: '45-2041',
    title: 'Graders and Sorters, Agricultural Products',
    group: 'Farming, Fishing & Forestry',
  },
  {
    code: '45-2091',
    title: 'Agricultural Equipment Operators',
    group: 'Farming, Fishing & Forestry',
  },
  {
    code: '45-2092',
    title: 'Farmworkers and Laborers, Crop, Nursery, and Greenhouse',
    group: 'Farming, Fishing & Forestry',
  },
  {
    code: '45-2093',
    title: 'Farmworkers, Farm, Ranch, and Aquacultural Animals',
    group: 'Farming, Fishing & Forestry',
  },
  {
    code: '45-2099',
    title: 'Agricultural Workers, All Other',
    group: 'Farming, Fishing & Forestry',
  },
  {
    code: '45-3011',
    title: 'Fishers and Related Fishing Workers',
    group: 'Farming, Fishing & Forestry',
  },
  {
    code: '45-4011',
    title: 'Forest and Conservation Workers',
    group: 'Farming, Fishing & Forestry',
  },
  { code: '45-4021', title: 'Fallers', group: 'Farming, Fishing & Forestry' },
  { code: '45-4022', title: 'Logging Equipment Operators', group: 'Farming, Fishing & Forestry' },
  { code: '45-4023', title: 'Log Graders and Scalers', group: 'Farming, Fishing & Forestry' },
  { code: '45-4029', title: 'Logging Workers, All Other', group: 'Farming, Fishing & Forestry' },

  // 47 — Construction & Extraction
  {
    code: '47-1011',
    title: 'First-Line Supervisors of Construction Trades',
    group: 'Construction & Extraction',
  },
  { code: '47-1011', title: 'Construction Managers', group: 'Construction & Extraction' },
  { code: '47-2011', title: 'Boilermakers', group: 'Construction & Extraction' },
  { code: '47-2021', title: 'Brickmasons and Blockmasons', group: 'Construction & Extraction' },
  { code: '47-2022', title: 'Stonemasons', group: 'Construction & Extraction' },
  { code: '47-2031', title: 'Carpenters', group: 'Construction & Extraction' },
  { code: '47-2041', title: 'Carpet Installers', group: 'Construction & Extraction' },
  { code: '47-2042', title: 'Floor Layers', group: 'Construction & Extraction' },
  { code: '47-2043', title: 'Floor Sanders and Finishers', group: 'Construction & Extraction' },
  { code: '47-2044', title: 'Tile and Stone Setters', group: 'Construction & Extraction' },
  {
    code: '47-2051',
    title: 'Cement Masons and Concrete Finishers',
    group: 'Construction & Extraction',
  },
  { code: '47-2061', title: 'Construction Laborers', group: 'Construction & Extraction' },
  {
    code: '47-2071',
    title: 'Paving, Surfacing, and Tamping Equipment Operators',
    group: 'Construction & Extraction',
  },
  { code: '47-2072', title: 'Pile Driver Operators', group: 'Construction & Extraction' },
  {
    code: '47-2073',
    title: 'Operating Engineers and Other Construction Equipment Operators',
    group: 'Construction & Extraction',
  },
  {
    code: '47-2081',
    title: 'Drywall and Ceiling Tile Installers',
    group: 'Construction & Extraction',
  },
  { code: '47-2082', title: 'Tapers', group: 'Construction & Extraction' },
  { code: '47-2111', title: 'Electricians', group: 'Construction & Extraction' },
  { code: '47-2121', title: 'Glaziers', group: 'Construction & Extraction' },
  {
    code: '47-2131',
    title: 'Insulation Workers, Floor, Ceiling, and Wall',
    group: 'Construction & Extraction',
  },
  { code: '47-2132', title: 'Insulation Workers, Mechanical', group: 'Construction & Extraction' },
  {
    code: '47-2141',
    title: 'Painters, Construction and Maintenance',
    group: 'Construction & Extraction',
  },
  { code: '47-2142', title: 'Paperhangers', group: 'Construction & Extraction' },
  { code: '47-2151', title: 'Pipelayers', group: 'Construction & Extraction' },
  {
    code: '47-2152',
    title: 'Plumbers, Pipefitters, and Steamfitters',
    group: 'Construction & Extraction',
  },
  { code: '47-2161', title: 'Plasterers and Stucco Masons', group: 'Construction & Extraction' },
  {
    code: '47-2171',
    title: 'Reinforcing Iron and Rebar Workers',
    group: 'Construction & Extraction',
  },
  { code: '47-2181', title: 'Roofers', group: 'Construction & Extraction' },
  { code: '47-2211', title: 'Sheet Metal Workers', group: 'Construction & Extraction' },
  {
    code: '47-2221',
    title: 'Structural Iron and Steel Workers',
    group: 'Construction & Extraction',
  },
  { code: '47-2231', title: 'Solar Photovoltaic Installers', group: 'Construction & Extraction' },
  {
    code: '47-3011',
    title: 'Helpers--Brickmasons, Blockmasons, Stonemasons',
    group: 'Construction & Extraction',
  },
  { code: '47-3012', title: 'Helpers--Carpenters', group: 'Construction & Extraction' },
  { code: '47-3013', title: 'Helpers--Electricians', group: 'Construction & Extraction' },
  { code: '47-3014', title: 'Helpers--Painters, Paperhangers', group: 'Construction & Extraction' },
  {
    code: '47-3015',
    title: 'Helpers--Pipelayers, Plumbers, Pipefitters',
    group: 'Construction & Extraction',
  },
  { code: '47-3016', title: 'Helpers--Roofers', group: 'Construction & Extraction' },
  {
    code: '47-3019',
    title: 'Helpers, Construction Trades, All Other',
    group: 'Construction & Extraction',
  },
  {
    code: '47-4011',
    title: 'Construction and Building Inspectors',
    group: 'Construction & Extraction',
  },
  {
    code: '47-4021',
    title: 'Elevator and Escalator Installers and Repairers',
    group: 'Construction & Extraction',
  },
  { code: '47-4031', title: 'Fence Erectors', group: 'Construction & Extraction' },
  {
    code: '47-4041',
    title: 'Hazardous Materials Removal Workers',
    group: 'Construction & Extraction',
  },
  { code: '47-4051', title: 'Highway Maintenance Workers', group: 'Construction & Extraction' },
  {
    code: '47-4061',
    title: 'Rail-Track Laying and Maintenance Equipment Operators',
    group: 'Construction & Extraction',
  },
  {
    code: '47-4099',
    title: 'Construction and Related Workers, All Other',
    group: 'Construction & Extraction',
  },
  { code: '47-5011', title: 'Derrick Operators, Oil and Gas', group: 'Construction & Extraction' },
  {
    code: '47-5013',
    title: 'Service Unit Operators, Oil and Gas',
    group: 'Construction & Extraction',
  },
  { code: '47-5021', title: 'Earth Drillers', group: 'Construction & Extraction' },
  {
    code: '47-5031',
    title: 'Explosives Workers, Ordnance Handling Experts',
    group: 'Construction & Extraction',
  },
  {
    code: '47-5041',
    title: 'Continuous Mining Machine Operators',
    group: 'Construction & Extraction',
  },
  {
    code: '47-5042',
    title: 'Mine Cutting and Channeling Machine Operators',
    group: 'Construction & Extraction',
  },
  { code: '47-5043', title: 'Roof Bolters, Mining', group: 'Construction & Extraction' },
  {
    code: '47-5044',
    title: 'Loading Machine Operators, Underground Mining',
    group: 'Construction & Extraction',
  },
  {
    code: '47-5049',
    title: 'Mining Machine Operators, All Other',
    group: 'Construction & Extraction',
  },
  { code: '47-5051', title: 'Rock Splitters, Quarry', group: 'Construction & Extraction' },
  {
    code: '47-5061',
    title: 'Rotary Drill Operators, Oil and Gas',
    group: 'Construction & Extraction',
  },
  { code: '47-5071', title: 'Roustabouts, Oil and Gas', group: 'Construction & Extraction' },
  { code: '47-5081', title: 'Helpers--Extraction Workers', group: 'Construction & Extraction' },
  { code: '47-5099', title: 'Extraction Workers, All Other', group: 'Construction & Extraction' },

  // 49 — Installation, Maintenance & Repair
  {
    code: '49-1011',
    title: 'First-Line Supervisors of Mechanics, Installers, and Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-2011',
    title: 'Computer, Automated Teller, and Office Machine Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-2021',
    title: 'Radio, Cellular, and Tower Equipment Installers and Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-2022',
    title: 'Telecommunications Equipment Installers and Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  { code: '49-2091', title: 'Avionics Technicians', group: 'Installation, Maintenance & Repair' },
  {
    code: '49-2092',
    title: 'Electric Motor, Power Tool, and Related Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-2093',
    title: 'Electrical and Electronics Installers and Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-2094',
    title: 'Electrical and Electronics Repairers, Commercial and Industrial',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-2095',
    title: 'Electrical and Electronics Repairers, Powerhouse',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-2096',
    title: 'Electronic Equipment Installers and Repairers, Motor Vehicles',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-2097',
    title: 'Electronic Home Entertainment Equipment Installers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-2098',
    title: 'Security and Fire Alarm Systems Installers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-3011',
    title: 'Aircraft Mechanics and Service Technicians',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-3021',
    title: 'Automotive Body and Related Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-3022',
    title: 'Automotive Glass Installers and Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-3023',
    title: 'Automotive Service Technicians and Mechanics',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-3031',
    title: 'Bus and Truck Mechanics and Diesel Engine Specialists',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-3041',
    title: 'Farm Equipment Mechanics and Service Technicians',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-3042',
    title: 'Mobile Heavy Equipment Mechanics',
    group: 'Installation, Maintenance & Repair',
  },
  { code: '49-3043', title: 'Rail Car Repairers', group: 'Installation, Maintenance & Repair' },
  {
    code: '49-3051',
    title: 'Motorboat Mechanics and Service Technicians',
    group: 'Installation, Maintenance & Repair',
  },
  { code: '49-3052', title: 'Motorcycle Mechanics', group: 'Installation, Maintenance & Repair' },
  {
    code: '49-3053',
    title: 'Outdoor Power Equipment and Other Small Engine Mechanics',
    group: 'Installation, Maintenance & Repair',
  },
  { code: '49-3091', title: 'Bicycle Repairers', group: 'Installation, Maintenance & Repair' },
  {
    code: '49-3092',
    title: 'Recreational Vehicle Service Technicians',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-3093',
    title: 'Tire Repairers and Changers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-3099',
    title: 'Vehicle and Mobile Equipment Mechanics, All Other',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9011',
    title: 'Mechanical Door Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9012',
    title: 'Control and Valve Installers and Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9021',
    title: 'Heating, Air Conditioning, and Refrigeration Mechanics',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9031',
    title: 'Home Appliance Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9041',
    title: 'Industrial Machinery Mechanics',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9043',
    title: 'Maintenance Workers, Machinery',
    group: 'Installation, Maintenance & Repair',
  },
  { code: '49-9044', title: 'Millwrights', group: 'Installation, Maintenance & Repair' },
  {
    code: '49-9045',
    title: 'Refractory Materials Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9051',
    title: 'Electrical Power-Line Installers and Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9052',
    title: 'Telecommunications Line Installers and Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9061',
    title: 'Camera and Photographic Equipment Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9062',
    title: 'Medical Equipment Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9063',
    title: 'Musical Instrument Repairers and Tuners',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9064',
    title: 'Watch and Clock Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9069',
    title: 'Precision Instrument and Equipment Repairers, All Other',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9071',
    title: 'Maintenance and Repair Workers, General',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9081',
    title: 'Wind Turbine Service Technicians',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9091',
    title: 'Coin, Vending, and Amusement Machine Servicers and Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9094',
    title: 'Locksmiths and Safe Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9095',
    title: 'Manufactured Building and Mobile Home Installers',
    group: 'Installation, Maintenance & Repair',
  },
  { code: '49-9096', title: 'Riggers', group: 'Installation, Maintenance & Repair' },
  {
    code: '49-9097',
    title: 'Signal and Track Switch Repairers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9098',
    title: 'Helpers--Installation, Maintenance, and Repair Workers',
    group: 'Installation, Maintenance & Repair',
  },
  {
    code: '49-9099',
    title: 'Installation, Maintenance, and Repair Workers, All Other',
    group: 'Installation, Maintenance & Repair',
  },

  // 51 — Production
  {
    code: '51-1011',
    title: 'First-Line Supervisors of Production and Operating Workers',
    group: 'Production',
  },
  {
    code: '51-2011',
    title: 'Aircraft Structure, Surfaces, Rigging, and Systems Assemblers',
    group: 'Production',
  },
  { code: '51-2021', title: 'Coil Winders, Tapers, and Finishers', group: 'Production' },
  { code: '51-2022', title: 'Electrical and Electronic Equipment Assemblers', group: 'Production' },
  { code: '51-2023', title: 'Electromechanical Equipment Assemblers', group: 'Production' },
  { code: '51-2024', title: 'Engine and Other Machine Assemblers', group: 'Production' },
  { code: '51-2031', title: 'Jewelers and Precious Stone and Metal Workers', group: 'Production' },
  { code: '51-2041', title: 'Structural Metal Fabricators and Fitters', group: 'Production' },
  { code: '51-2051', title: 'Fiberglass Laminators and Fabricators', group: 'Production' },
  { code: '51-2061', title: 'Timing Device Assemblers and Adjusters', group: 'Production' },
  { code: '51-2091', title: 'Adhesive Bonding Machine Operators and Tenders', group: 'Production' },
  { code: '51-2092', title: 'Team Assemblers', group: 'Production' },
  { code: '51-2093', title: 'Timing Device Assemblers and Adjusters', group: 'Production' },
  { code: '51-2099', title: 'Assemblers and Fabricators, All Other', group: 'Production' },
  { code: '51-3011', title: 'Bakers', group: 'Production' },
  { code: '51-3021', title: 'Butchers and Meat Cutters', group: 'Production' },
  { code: '51-3022', title: 'Meat, Poultry, and Fish Cutters and Trimmers', group: 'Production' },
  { code: '51-3023', title: 'Slaughterers and Meat Packers', group: 'Production' },
  { code: '51-3031', title: 'Bakers', group: 'Production' },
  { code: '51-3092', title: 'Food Batchmakers', group: 'Production' },
  { code: '51-3093', title: 'Food Cooking Machine Operators and Tenders', group: 'Production' },
  { code: '51-3099', title: 'Food Processing Workers, All Other', group: 'Production' },
  { code: '51-4011', title: 'Computer Numerically Controlled Tool Operators', group: 'Production' },
  {
    code: '51-4012',
    title: 'Computer Numerically Controlled Tool Programmers',
    group: 'Production',
  },
  {
    code: '51-4021',
    title: 'Extruding and Drawing Machine Setters, Metal and Plastic',
    group: 'Production',
  },
  {
    code: '51-4022',
    title: 'Forging Machine Setters, Operators, and Tenders',
    group: 'Production',
  },
  {
    code: '51-4023',
    title: 'Rolling Machine Setters, Operators, and Tenders',
    group: 'Production',
  },
  { code: '51-4031', title: 'Cutting, Punching, and Press Machine Setters', group: 'Production' },
  {
    code: '51-4033',
    title: 'Grinding, Lapping, Polishing, and Buffing Machine Operators',
    group: 'Production',
  },
  { code: '51-4041', title: 'Machinists', group: 'Production' },
  { code: '51-4051', title: 'Metal-Refining Furnace Operators and Tenders', group: 'Production' },
  { code: '51-4061', title: 'Model Makers, Metal and Plastic', group: 'Production' },
  { code: '51-4062', title: 'Patternmakers, Metal and Plastic', group: 'Production' },
  { code: '51-4071', title: 'Foundry Mold and Coremakers', group: 'Production' },
  {
    code: '51-4072',
    title: 'Molding, Coremaking, and Casting Machine Setters',
    group: 'Production',
  },
  {
    code: '51-4081',
    title: 'Multiple Machine Tool Setters, Operators, and Tenders',
    group: 'Production',
  },
  { code: '51-4111', title: 'Tool and Die Makers', group: 'Production' },
  { code: '51-4121', title: 'Welders, Cutters, Solderers, and Brazers', group: 'Production' },
  {
    code: '51-4122',
    title: 'Welding, Soldering, and Brazing Machine Setters',
    group: 'Production',
  },
  {
    code: '51-4191',
    title: 'Heat Treating Equipment Setters, Operators, and Tenders',
    group: 'Production',
  },
  { code: '51-4192', title: 'Layout Workers, Metal and Plastic', group: 'Production' },
  {
    code: '51-4193',
    title: 'Plating Machine Setters, Operators, and Tenders, Metal',
    group: 'Production',
  },
  { code: '51-4194', title: 'Tool Grinders, Filers, and Sharpeners', group: 'Production' },
  { code: '51-4199', title: 'Metal Workers and Plastic Workers, All Other', group: 'Production' },
  { code: '51-5111', title: 'Prepress Technicians and Workers', group: 'Production' },
  { code: '51-5112', title: 'Printing Press Operators', group: 'Production' },
  { code: '51-5113', title: 'Print Binding and Finishing Workers', group: 'Production' },
  { code: '51-6011', title: 'Laundry and Dry-Cleaning Workers', group: 'Production' },
  {
    code: '51-6021',
    title: 'Pressers, Textile, Garment, and Related Materials',
    group: 'Production',
  },
  { code: '51-6031', title: 'Sewing Machine Operators', group: 'Production' },
  { code: '51-6041', title: 'Shoe and Leather Workers and Repairers', group: 'Production' },
  { code: '51-6042', title: 'Shoe Machine Operators and Tenders', group: 'Production' },
  { code: '51-6051', title: 'Sewers, Hand', group: 'Production' },
  { code: '51-6052', title: 'Tailors, Dressmakers, and Custom Sewers', group: 'Production' },
  { code: '51-6061', title: 'Textile Bleaching and Dyeing Machine Operators', group: 'Production' },
  {
    code: '51-6062',
    title: 'Textile Cutting Machine Setters, Operators, and Tenders',
    group: 'Production',
  },
  { code: '51-6063', title: 'Textile Knitting and Weaving Machine Setters', group: 'Production' },
  {
    code: '51-6064',
    title: 'Textile Winding, Twisting, and Drawing Out Machine Setters',
    group: 'Production',
  },
  {
    code: '51-6091',
    title: 'Extruding and Forming Machine Setters, Operators, Synthetic',
    group: 'Production',
  },
  { code: '51-6092', title: 'Fabric and Apparel Patternmakers', group: 'Production' },
  { code: '51-6093', title: 'Upholsterers', group: 'Production' },
  {
    code: '51-6099',
    title: 'Textile, Apparel, and Furnishings Workers, All Other',
    group: 'Production',
  },
  { code: '51-7011', title: 'Cabinetmakers and Bench Carpenters', group: 'Production' },
  { code: '51-7021', title: 'Furniture Finishers', group: 'Production' },
  { code: '51-7031', title: 'Model Makers, Wood', group: 'Production' },
  { code: '51-7032', title: 'Patternmakers, Wood', group: 'Production' },
  { code: '51-7041', title: 'Sawing Machine Setters, Operators, and Tenders', group: 'Production' },
  {
    code: '51-7042',
    title: 'Woodworking Machine Setters, Operators, and Tenders',
    group: 'Production',
  },
  { code: '51-7099', title: 'Woodworkers, All Other', group: 'Production' },
  { code: '51-8011', title: 'Nuclear Power Reactor Operators', group: 'Production' },
  { code: '51-8012', title: 'Power Distributors and Dispatchers', group: 'Production' },
  { code: '51-8013', title: 'Power Plant Operators', group: 'Production' },
  { code: '51-8021', title: 'Stationary Engineers and Boiler Operators', group: 'Production' },
  { code: '51-8031', title: 'Water and Wastewater Treatment Plant Operators', group: 'Production' },
  { code: '51-8091', title: 'Chemical Plant and System Operators', group: 'Production' },
  { code: '51-8092', title: 'Gas Plant Operators', group: 'Production' },
  { code: '51-8093', title: 'Petroleum Pump System Operators', group: 'Production' },
  { code: '51-8099', title: 'Plant and System Operators, All Other', group: 'Production' },
  { code: '51-9011', title: 'Chemical Equipment Operators and Tenders', group: 'Production' },
  {
    code: '51-9012',
    title: 'Separating, Filtering, Clarifying, Precipitating Operators',
    group: 'Production',
  },
  {
    code: '51-9021',
    title: 'Crushing, Grinding, and Polishing Machine Setters',
    group: 'Production',
  },
  { code: '51-9023', title: 'Mixing and Blending Machine Setters, Operators', group: 'Production' },
  { code: '51-9031', title: 'Cutters and Trimmers, Hand', group: 'Production' },
  {
    code: '51-9032',
    title: 'Cutting and Slicing Machine Setters, Operators, and Tenders',
    group: 'Production',
  },
  {
    code: '51-9041',
    title: 'Extruding, Forming, Pressing, and Compacting Machine Setters',
    group: 'Production',
  },
  {
    code: '51-9051',
    title: 'Furnace, Kiln, Oven, Drier, and Kettle Operators',
    group: 'Production',
  },
  {
    code: '51-9061',
    title: 'Inspectors, Testers, Sorters, Samplers, and Weighers',
    group: 'Production',
  },
  { code: '51-9071', title: 'Jewelers and Precious Stone and Metal Workers', group: 'Production' },
  { code: '51-9081', title: 'Dental Laboratory Technicians', group: 'Production' },
  { code: '51-9082', title: 'Medical Appliance Technicians', group: 'Production' },
  { code: '51-9083', title: 'Ophthalmic Laboratory Technicians', group: 'Production' },
  { code: '51-9084', title: 'Timing Device Assemblers and Adjusters', group: 'Production' },
  {
    code: '51-9111',
    title: 'Packaging and Filling Machine Operators and Tenders',
    group: 'Production',
  },
  {
    code: '51-9121',
    title: 'Coating, Painting, and Spraying Machine Setters',
    group: 'Production',
  },
  { code: '51-9122', title: 'Painters, Transportation Equipment', group: 'Production' },
  { code: '51-9123', title: 'Painting, Coating, and Decorating Workers', group: 'Production' },
  {
    code: '51-9131',
    title: 'Photographic Process Workers and Processing Machine Operators',
    group: 'Production',
  },
  { code: '51-9141', title: 'Semiconductor Processing Technicians', group: 'Production' },
  { code: '51-9151', title: 'Adhesive Bonding Machine Operators and Tenders', group: 'Production' },
  { code: '51-9161', title: 'Computer Numerically Controlled Tool Operators', group: 'Production' },
  { code: '51-9191', title: 'Adhesive Bonding Machine Operators', group: 'Production' },
  {
    code: '51-9192',
    title: 'Cleaning, Washing, and Metal Pickling Equipment Operators',
    group: 'Production',
  },
  { code: '51-9193', title: 'Etchers and Engravers', group: 'Production' },
  { code: '51-9194', title: 'Molders, Shapers, and Casters', group: 'Production' },
  {
    code: '51-9195',
    title: 'Paper Goods Machine Setters, Operators, and Tenders',
    group: 'Production',
  },
  { code: '51-9196', title: 'Refuse and Recyclable Material Collectors', group: 'Production' },
  { code: '51-9197', title: 'Tire Builders', group: 'Production' },
  { code: '51-9198', title: 'Helpers--Production Workers', group: 'Production' },
  { code: '51-9199', title: 'Production Workers, All Other', group: 'Production' },

  // 53 — Transportation & Material Moving
  {
    code: '53-1011',
    title: 'Aircraft Cargo Handling Supervisors',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-1042',
    title: 'First-Line Supervisors of Helpers, Laborers, and Material Movers',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-1043',
    title: 'First-Line Supervisors of Material-Moving Machine and Vehicle Operators',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-1044',
    title: 'First-Line Supervisors of Passenger Attendants',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-2011',
    title: 'Airline Pilots, Copilots, and Flight Engineers',
    group: 'Transportation & Material Moving',
  },
  { code: '53-2012', title: 'Commercial Pilots', group: 'Transportation & Material Moving' },
  { code: '53-2021', title: 'Air Traffic Controllers', group: 'Transportation & Material Moving' },
  {
    code: '53-2022',
    title: 'Airfield Operations Specialists',
    group: 'Transportation & Material Moving',
  },
  { code: '53-2031', title: 'Flight Attendants', group: 'Transportation & Material Moving' },
  {
    code: '53-3011',
    title: 'Ambulance Drivers and Attendants',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-3021',
    title: 'Bus Drivers, Transit and Intercity',
    group: 'Transportation & Material Moving',
  },
  { code: '53-3022', title: 'Bus Drivers, School', group: 'Transportation & Material Moving' },
  { code: '53-3031', title: 'Driver/Sales Workers', group: 'Transportation & Material Moving' },
  {
    code: '53-3032',
    title: 'Heavy and Tractor-Trailer Truck Drivers',
    group: 'Transportation & Material Moving',
  },
  { code: '53-3033', title: 'Light Truck Drivers', group: 'Transportation & Material Moving' },
  { code: '53-3041', title: 'Taxi Drivers', group: 'Transportation & Material Moving' },
  {
    code: '53-3042',
    title: 'Passenger Vehicle Drivers',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-3051',
    title: 'Bus Drivers, Transit and Intercity',
    group: 'Transportation & Material Moving',
  },
  { code: '53-3052', title: 'Forklift Operators', group: 'Transportation & Material Moving' },
  { code: '53-3053', title: 'Parking Attendants', group: 'Transportation & Material Moving' },
  {
    code: '53-3054',
    title: 'Transportation Inspectors',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-3099',
    title: 'Motor Vehicle Operators, All Other',
    group: 'Transportation & Material Moving',
  },
  { code: '53-4011', title: 'Locomotive Engineers', group: 'Transportation & Material Moving' },
  { code: '53-4012', title: 'Locomotive Firers', group: 'Transportation & Material Moving' },
  {
    code: '53-4013',
    title: 'Rail Yard Engineers, Dinkey Operators, and Hostlers',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-4021',
    title: 'Railroad Brake, Signal, and Switch Operators',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-4031',
    title: 'Railroad Conductors and Yardmasters',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-4041',
    title: 'Subway and Streetcar Operators',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-4099',
    title: 'Rail Transportation Workers, All Other',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-5011',
    title: 'Sailors and Marine Oilers',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-5021',
    title: 'Captains, Mates, and Pilots of Water Vessels',
    group: 'Transportation & Material Moving',
  },
  { code: '53-5031', title: 'Ship Engineers', group: 'Transportation & Material Moving' },
  { code: '53-6011', title: 'Bridge and Lock Tenders', group: 'Transportation & Material Moving' },
  { code: '53-6021', title: 'Parking Attendants', group: 'Transportation & Material Moving' },
  {
    code: '53-6031',
    title: 'Automotive and Watercraft Service Attendants',
    group: 'Transportation & Material Moving',
  },
  { code: '53-6041', title: 'Traffic Technicians', group: 'Transportation & Material Moving' },
  {
    code: '53-6051',
    title: 'Transportation Inspectors',
    group: 'Transportation & Material Moving',
  },
  { code: '53-6061', title: 'Passenger Attendants', group: 'Transportation & Material Moving' },
  {
    code: '53-6099',
    title: 'Transportation Workers, All Other',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-7011',
    title: 'Conveyor Operators and Tenders',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-7021',
    title: 'Crane and Tower Operators',
    group: 'Transportation & Material Moving',
  },
  { code: '53-7031', title: 'Dredge Operators', group: 'Transportation & Material Moving' },
  {
    code: '53-7032',
    title: 'Excavating and Loading Machine and Dragline Operators',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-7033',
    title: 'Loading Machine Operators, Underground Mining',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-7041',
    title: 'Hoist and Winch Operators',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-7051',
    title: 'Industrial Truck and Tractor Operators',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-7061',
    title: 'Cleaners of Vehicles and Equipment',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-7062',
    title: 'Laborers and Freight, Stock, and Material Movers',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-7063',
    title: 'Machine Feeders and Offbearers',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-7064',
    title: 'Packers and Packagers, Hand',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-7065',
    title: 'Stockers and Order Fillers',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-7070',
    title: 'Pumping Station Operators',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-7081',
    title: 'Refuse and Recyclable Material Collectors',
    group: 'Transportation & Material Moving',
  },
  {
    code: '53-7099',
    title: 'Material Moving Workers, All Other',
    group: 'Transportation & Material Moving',
  },

  // Product Management (common non-SOC titles widely used)
  {
    code: '11-2099',
    title: 'Product Manager',
    group: 'Management',
    aliases: [
      'PM',
      'APM',
      'Associate PM',
      'Associate Product Manager',
      'Group PM',
      'GPM',
      'Senior PM',
      'Principal PM',
      'CPO',
      'Chief Product Officer',
      'Head of Product',
      'VP Product',
    ],
  },
  { code: '11-2098', title: 'Product Marketing Manager', group: 'Management' },
  { code: '11-2097', title: 'Growth Manager', group: 'Management' },
  { code: '15-1299', title: 'Machine Learning Engineer', group: 'Computer & Mathematical' },
  { code: '15-1298', title: 'AI Engineer', group: 'Computer & Mathematical' },
  { code: '15-1297', title: 'Frontend Engineer', group: 'Computer & Mathematical' },
  { code: '15-1296', title: 'Backend Engineer', group: 'Computer & Mathematical' },
  { code: '15-1295', title: 'Full Stack Engineer', group: 'Computer & Mathematical' },
  { code: '15-1294', title: 'Mobile Engineer', group: 'Computer & Mathematical' },
  { code: '15-1293', title: 'Site Reliability Engineer', group: 'Computer & Mathematical' },
  { code: '15-1292', title: 'Platform Engineer', group: 'Computer & Mathematical' },
  { code: '15-1291', title: 'Cloud Engineer', group: 'Computer & Mathematical' },
  { code: '15-1290', title: 'Security Engineer', group: 'Computer & Mathematical' },
  {
    code: '27-1099',
    title: 'UX Designer',
    group: 'Arts, Design & Media',
    aliases: ['UX', 'UI/UX Designer', 'UI Designer', 'Interaction Designer', 'Experience Designer'],
  },
  { code: '27-1098', title: 'Product Designer', group: 'Arts, Design & Media' },
  { code: '27-1097', title: 'Brand Designer', group: 'Arts, Design & Media' },
  { code: '13-1299', title: 'Strategy Consultant', group: 'Business & Financial' },
  { code: '13-1298', title: 'Management Consultant', group: 'Business & Financial' },
  { code: '13-1297', title: 'Business Analyst', group: 'Business & Financial' },
  { code: '13-1296', title: 'Operations Analyst', group: 'Business & Financial' },
  { code: '13-1295', title: 'Data Analyst', group: 'Business & Financial' },
  { code: '13-1294', title: 'Investment Banking Analyst', group: 'Business & Financial' },
  { code: '13-1293', title: 'Private Equity Analyst', group: 'Business & Financial' },
  { code: '13-1292', title: 'Venture Capital Analyst', group: 'Business & Financial' },
  { code: '13-1291', title: 'Supply Chain Analyst', group: 'Business & Financial' },
  { code: '13-1290', title: 'Procurement Analyst', group: 'Business & Financial' },
  { code: '11-2096', title: 'Brand Manager', group: 'Management' },
  { code: '11-2095', title: 'Content Marketing Manager', group: 'Management' },
  { code: '11-2094', title: 'Digital Marketing Manager', group: 'Management' },
  { code: '11-2093', title: 'Social Media Manager', group: 'Management' },
  { code: '11-2092', title: 'Account Manager', group: 'Management' },
  { code: '11-2091', title: 'Customer Success Manager', group: 'Management' },
  { code: '11-2090', title: 'Program Manager', group: 'Management' },
  { code: '11-2089', title: 'Scrum Master', group: 'Management' },
  { code: '11-2088', title: 'Delivery Manager', group: 'Management' },
  { code: '11-2087', title: 'Chief of Staff', group: 'Management' },
  { code: '11-2086', title: 'Business Development Manager', group: 'Management' },
  {
    code: '13-1289',
    title: 'UX Researcher',
    group: 'Business & Financial',
    aliases: [
      'User Researcher',
      'Design Researcher',
      'Qualitative Researcher',
      'Mixed Methods Researcher',
    ],
  },
  { code: '13-1288', title: 'Product Analyst', group: 'Business & Financial' },
]
